export function PausedScreen({
  message,
  until,
}: {
  message: string;
  until: string | null;
}) {
  const back = until
    ? new Date(until).toLocaleTimeString([], {
        hour: "numeric",
        minute: "2-digit",
      })
    : null;
  return (
    <main className="grid min-h-dvh place-items-center px-6 py-16 text-center">
      <div className="max-w-xl">
        <p className="text-xs font-semibold tracking-widest text-[var(--action)] uppercase">
          SYLVIQ is paused
        </p>
        <h1 className="mt-3 text-4xl font-semibold tracking-tight text-balance sm:text-5xl">
          We&apos;re under attack. Be back soon.
        </h1>
        <p className="mt-5 text-base text-[var(--muted-foreground)] sm:text-lg">
          {message}
        </p>
        {back ? (
          <p className="mt-3 text-sm text-[var(--muted-foreground)]">
            We expect to be back around {back}.
          </p>
        ) : null}
        <p className="mt-8 text-xs text-[var(--muted-foreground)]">
          This page checks again automatically — there is no need to refresh.
        </p>
      </div>
    </main>
  );
}
